import { Box, Container } from '@mui/material'
import React, { useState } from 'react'
import {useHistory} from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import {BUTTON_PRIMARY, TOAST_SUCCESS} from '../assets/constants/Constants';
import {ASSIGNMENT_SELECTION, LOGIN} from '../assets/constants/PageList';
import {checkIfAssignmentIsProperlyConfigured, getPathForNextPage} from '../lib/Utils';
import ButtonComponent from '../components/ButtonComponent';
import CustomDialog from '../components/CustomDialog';
import ShowToast from '../components/ToastComponent';

const UseCaseListScreenPage = () => {
  	const history = useHistory();
  	const {t} = useTranslation();
  	const {tenantAndAssignmentSettings} = history.location?.state;
  	const assignmentList = tenantAndAssignmentSettings?.locker_assignments;
	const [isDialogVisible, setIsDialogVisible] = useState(false);
	const [dialogContentText, setDialogContentText] = useState('');

	const showErrorDialog = (dialogContentText) => {
		setDialogContentText(dialogContentText);
		setIsDialogVisible(true);
	}

	const assignmentSelectionHandler = async (assignment, selectedAssignmentIndex) => {
		const isAssignmentProperlyConfigured = await checkIfAssignmentIsProperlyConfigured(tenantAndAssignmentSettings, selectedAssignmentIndex);

		if ( isAssignmentProperlyConfigured === true ) {
			ShowToast(`"${assignment.name.toUpperCase()}" assignment is selected.`, TOAST_SUCCESS);
            history.push({
				pathname: getPathForNextPage(ASSIGNMENT_SELECTION, LOGIN)
			});
		}
		else {
			showErrorDialog( t(isAssignmentProperlyConfigured?.errorMessage) );
		}
	}

  	return (
    	<Box className='assignment-selection-page'>
    		<Box className='main-container'>
        		<Box className='main'>
                    {assignmentList.map((assignment, index) => (
                        <ButtonComponent
                            key={index}
                            buttonId={`assignment-${index}`}
                            title={assignment.name.toUpperCase()}
                            handleClick={() => assignmentSelectionHandler(assignment, index)}
                        />
                    ))}
                    <CustomDialog
                        dialogId='error-dialog'
                        dialogVisible={isDialogVisible}
                        dialogTitle={t('page_title_error')}
                        dialogContentText={dialogContentText}
                        buttonTwoTitle={t('button_ok')}
                        buttonProps={{ buttonTwo: {type: BUTTON_PRIMARY } }}
                        handleAccept={() => setIsDialogVisible(false)}
                    />
                </Box>
    		</Box>
  		</Box>
  	)
}

export default UseCaseListScreenPage

